import { Decorators, EditorUtils, EntityDialog } from "@serenity-is/corelib";
import { DataAuditLogForm, DataAuditLogRow, DataAuditLogService } from "../ServerTypes/Pro";

@Decorators.registerClass('Serenity.Pro.DataAuditLog.DataAuditLogGrid')
export class DataAuditLogDialog<P = {}> extends EntityDialog<DataAuditLogRow, P> {
    protected getFormKey() { return DataAuditLogForm.formKey; }
    protected getIdProperty() { return DataAuditLogRow.idProperty; }
    protected getNameProperty() { return DataAuditLogRow.idProperty; }
    protected getLocalTextPrefix() { return DataAuditLogRow.localTextPrefix; }
    protected getService() { return DataAuditLogService.baseUrl; }

    protected form = new DataAuditLogForm(this.idPrefix);

    protected getToolbarButtons() {
        return [];
    }

    protected updateInterface() {
        super.updateInterface();

        EditorUtils.setReadonly(Array.from(this.domNode.querySelectorAll('.editor')), true);
    }
}
